import { Injectable } from '@angular/core';
import { NotificationPaginatedResVm, NotificationPaginatedVm } from '@core/models/NotificationModel';
import { BaseDataService } from '@core/service/base-data.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationDataService {
private  apiNotificationUrl:string="api/Notifications"
  constructor(private baseDataService:BaseDataService) { }

  getUnreadCount(): Observable<number>{
    return this.baseDataService.makeGetCall(this.apiNotificationUrl+'/unreadCount')
  } 

  getNotificationsList(notificationReq:NotificationPaginatedVm): Observable<NotificationPaginatedResVm> {
    return this.baseDataService.makePostCall(`${this.apiNotificationUrl}/list`,notificationReq)
  }

  markAsReadById(id: string): Observable<boolean> {
    return this.baseDataService.makePutCall(`${this.apiNotificationUrl}/markAsRead/${id}`,null)
  }

  markAllAsRead(): Observable<boolean> {
    return this.baseDataService.makePutCall(`${this.apiNotificationUrl}/markAllAsRead`,null)
  }
}
